<div class="row match-height justify-content-center">
    <div class="col-md-12">
        <div class="content-wrapper container-xxl p-0">
            <div class="content-body">
                <app-content-header [contentHeader]="contentHeader"></app-content-header>

                <div class="row match-height">
                    <!-- Company Table -->
                    <div class="col-lg-12 col-12">
                      <div class="card card-company-table">
                        <div class="card-body p-0">
                          <div class="table-responsive">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th>Customer</th>
                                  <th>Description</th>
                                  <th>Receiver</th>
                                  <th>Reference</th>
                                  <th>Amount</th>
                                </tr>
                              </thead>
                              <tbody *ngIf="transactions.length === 0">
                                <tr>
                                  <td colspan="4">No transactions found.</td>
                                </tr>
                              </tbody>
                              <tbody *ngIf="transactions.length > 0">
                                <tr *ngFor="let item of transactions">
                                  <td>
                                    <div class="d-flex align-items-center">
                                      <div class="avatar rounded">
                                        <div class="avatar-content">
                                          <img src="assets/images/icons/rocket.svg" alt="Rocket svg" />
                                        </div>
                                      </div>
                                      <div>
                                        <div class="font-weight-bolder">{{ item.user_id }}</div>
                                        <div class="font-small-2 text-muted">Wallet ID</div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center">
                                      <div class="avatar bg-light-primary mr-1">
                                        <div class="avatar-content">
                                          <i data-feather="monitor" class="font-medium-3"></i>
                                        </div>
                                      </div>
                                      <span>{{ item.descc }}</span>
                                    </div>
                                  </td>
                                  <td class="text-nowrap">
                                    <div class="d-flex flex-column">
                                      <span class="font-weight-bolder mb-25">{{ item.send_to }}</span>
                                      <span class="font-small-2 text-muted">{{ item.created_at }}</span>
                                    </div>
                                  </td>
                                  <td>
                                    {{ item.trans_id }}
                                  </td>
                                  <td class="text-nowrap">
                                    <div class="d-flex flex-column align-items-center">
                                      <div *ngIf="item.type =='fund'" class="font-weight-bolder text-success"><small>+ {{ item.amount | currency: "₦" }}</small></div>
                                      <div *ngIf="item.type !=='fund'" class="font-weight-bolder text-danger"><small>- {{ item.amount | currency: "₦" }}</small></div>
                                      <span *ngIf="item.status ==0">
                                        <i data-feather="trending-up" class="text-warning font-medium-1"></i> Pending
                                      </span>
                                      <span *ngIf="item.status ==1">
                                        <i data-feather="trending-up" class="text-success font-medium-1"></i> Success
                                      </span>
                                      <span *ngIf="item.status ==2">
                                        <i data-feather="trending-down" class="text-danger font-medium-1"></i> Fail
                                      </span>
                                      <span *ngIf="item.status ==3">
                                        <i data-feather="trending-up" class="text-primary font-medium-1"></i> Reversed
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
            </div>
        </div>
    </div>
</div>

